export const iconFontAwesomeMusicVideoDrum = (
	<i className="fa-solid fa-drum"></i>
);
